import React, { useEffect, useState } from 'react';
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  TextField,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { toast } from 'react-toastify';
import { rejectParticipationCancellationRequest } from '../../../controllers/participationCancellationController';

const fieldSx = {
  '& .MuiOutlinedInput-root': { borderRadius: '5px' },
  '& .MuiInputBase-input': { fontSize: '14px' },
};

const RejectParticipationCancellationDialog = ({
  open,
  onClose,
  requestId,
  onRejected,
}) => {
  const [rejectionReason, setRejectionReason] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open) return;
    setRejectionReason('');
    setError('');
    setSubmitting(false);
  }, [open, requestId]);

  const handleSubmit = async () => {
    if (!requestId) return;
    if (!rejectionReason.trim()) {
      setError('Red sebebi zorunludur');
      return;
    }
    setSubmitting(true);
    setError('');
    try {
      await rejectParticipationCancellationRequest(requestId, {
        rejectionReason: rejectionReason.trim(),
      });
      toast.success('İptal talebi reddedildi');
      onClose();
      if (onRejected) onRejected();
    } catch (e) {
      setError(e?.message || 'Red işlemi başarısız');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', pr: 3 }}>
        İptal Talebini Reddet
        <IconButton onClick={onClose} size="small" disabled={submitting}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ px: 3, py: 2 }}>
        <Stack spacing={2} sx={{ mt: 1 }}>
          {error && <Alert severity="error">{error}</Alert>}
          <Alert severity="info" sx={{ fontSize: '13px' }}>
            Red sonrası katılım ve ödemeler değişmez.
          </Alert>
          <TextField
            label="Red sebebi"
            multiline
            rows={4}
            value={rejectionReason}
            onChange={(e) => setRejectionReason(e.target.value)}
            required
            fullWidth
            sx={fieldSx}
          />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={submitting} sx={{ textTransform: 'none' }}>Vazgeç</Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={submitting}
          sx={{ textTransform: 'none', backgroundColor: '#F8285A' }}
        >
          {submitting ? <CircularProgress size={18} color="inherit" /> : 'Reddet'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RejectParticipationCancellationDialog;
